
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"72","height":"72","viewBox":"0 0 72 72","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"72","height":"72","rx":"36","fill":"#F4F0FA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.5 20.5H29.5V18C29.5 17.1716 28.8284 16.5 28 16.5C27.1716 16.5 26.5 17.1716 26.5 18V20.5H21C18.5147 20.5 16.5 22.5147 16.5 25V49C16.5 51.4853 18.5147 53.5 21 53.5H40.6296C40.278 52.559 40.064 51.5508 40.0123 50.5H21C20.1716 50.5 19.5 49.8284 19.5 49V33.5H52.5V40.315C53.5817 40.5934 54.5925 41.0483 55.5 41.647V25C55.5 22.5147 53.4853 20.5 51 20.5H45.5V18C45.5 17.1716 44.8284 16.5 44 16.5C43.1716 16.5 42.5 17.1716 42.5 18V20.5ZM21 23.5H51C51.8284 23.5 52.5 24.1716 52.5 25V30.5H19.5V25C19.5 24.1716 20.1716 23.5 21 23.5Z","fill":"#7344C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42 49C42 45.134 45.134 42 49 42C52.866 42 56 45.134 56 49C56 52.866 52.866 56 49 56C45.134 56 42 52.866 42 49ZM51.4712 47.2712C51.6763 47.0662 51.6763 46.7338 51.4712 46.5288C51.2662 46.3237 50.9338 46.3237 50.7288 46.5288L49 48.2575L47.2712 46.5288C47.0662 46.3237 46.7338 46.3237 46.5288 46.5288C46.3237 46.7338 46.3237 47.0662 46.5288 47.2712L48.2575 49L46.5288 50.7288C46.3237 50.9338 46.3237 51.2662 46.5288 51.4712C46.7338 51.6763 47.0662 51.6763 47.2712 51.4712L49 49.7425L50.7288 51.4712C50.9338 51.6763 51.2662 51.6763 51.4712 51.4712C51.6763 51.2662 51.6763 50.9338 51.4712 50.7288L49.7425 49L51.4712 47.2712Z","fill":"#7344C0"}})])
          )
        }
      }
    